import { TableColumn } from '@fl/cmsch-fe-library';
import { ColumnHeader } from 'api/gen/ColumnHeader';
import { TFunction } from 'app/translations';
import { ManagementAssociationsTableType } from '../../types/management-associations';
const genDynamicColumns = (columns: Array<ColumnHeader>, t: TFunction<'admin'>, removeUsersFromRole: (roleId: string) => void, handleColumnOpenCreateModal: (roleId: string, roleName: string) => void): Array<TableColumn<ManagementAssociationsTableType>> => columns.map(column => ({
  field: column.id.toString(),
  column: column.code,
  tooltip: column.code,
  type: 'dynamicReactNode',
  width: 180,
  align: 'center',
  specialHeaderOnClickActions: {
    create: handleColumnOpenCreateModal,
    delete: removeUsersFromRole,
    deleteConfirmTitle: t('confirmRemovingRoleForUsers', {
      role: column.code
    })
  }
}));

/**
 * Builds the association-management table columns.
 *
 * @param dynamicColumns Role columns fetched from the API.
 * @param t Translation helper for admin strings.
 * @param tCommon Translation helper for common strings.
 * @param removeUsersFromRole Removes a role binding from the selected subject.
 * @param handleColumnOpenCreateModal Opens the binding creation modal for a role.
 * @returns Table columns for the association-management table.
 */
export const managementAssociationsColumns = (dynamicColumns: Array<ColumnHeader>, t: TFunction<'admin'>, tCommon: TFunction<'common'>, removeUsersFromRole: (roleId: string) => void, handleColumnOpenCreateModal: (roleId: string, roleName: string) => void): Array<TableColumn<ManagementAssociationsTableType>> => [{
  field: 'username',
  column: tCommon('firstName'),
  type: 'string',
  width: 180,
  locked: true,
  filterTypes: ['containsStringOr', {
    type: 'multiSelectStringOrEquals',
    subtype: 'bulkString'
  }]
}, ...genDynamicColumns(dynamicColumns, t, removeUsersFromRole, handleColumnOpenCreateModal)];